/**
 * AddUserModal
 */

import React from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { useApi2call } from 'containers/Api2/index.js';
import FormModal from 'components/interaction/FormModal/index.jsx';
import prepareBody from './prepareBody.js';
import makeUrlSelector from './makeUrlSelector.js';

function AddUserModal(props) {
  const { title, show, schema, defaultValues, onClose, type } = props;
  const api2call = useApi2call();
  const navigate = useNavigate();

  const { url, selector } = makeUrlSelector(type);
  async function handleSubmit(data) {
    const res = await api2call({
      method: 'POST',
      url,
      selector,
      version: 2,
      body: prepareBody(data),
      withPromise: true,
    });
    navigate(`/admin/users/${type}/${res.id}`);
  }

  return (
    <FormModal
      show={show}
      size="sm"
      title={title}
      schema={schema}
      values={defaultValues}
      onSubmit={handleSubmit}
      onHide={onClose}
    />
  );
}

AddUserModal.propTypes = {
  show: PropTypes.bool,
  title: PropTypes.object.isRequired,
  type: PropTypes.string.isRequired,
  schema: PropTypes.object.isRequired,
  defaultValues: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default AddUserModal;
